import { isTokenValid } from "../../helper/tokenValidation";
import { performTokenRefresh } from "../api/common";

export const isUserAuthenticated = async () => {
  if (!isTokenValid()) {
    try {
      await performTokenRefresh();
      return true;
    } catch {
      return false;
    }
  } else {
    return true;
  }
};
